import { FETCH_ONBOARDING_STATE } from '@/graphql/account/provider/queries';
import { readDomainCookie } from '../domain_cookie';

async function sitterOnboardingState(apolloProvider) {
  try {
    const { data } = await apolloProvider.defaultClient.query({
      query: FETCH_ONBOARDING_STATE,
    });
    return data.onboardingState.SitterOnboardingState;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching onboarding state:', error);
    throw new Error('Failed to fetch onboarding state');
  }
}

const stateToRouteMap = {
  ADDRESS: '/sitter/signup/address',
  PROFILE: '/sitter/signup/care-type',
  IDV: '/sitter/verify_identity',
  BGC: '/sitter/background_check_id_failed',
  BGC_SUBMIT: '/sitter/background_check_order',
  PHOTO: '/sitter/complete',
};

function routeForOnboardingState(state: string) {
  return stateToRouteMap[state];
}

async function redirectIfNotOnboarded(apolloProvider, account) {
  if (!account?.isSitter()) return false;

  const onboardingState = await sitterOnboardingState(apolloProvider);
  const isAdditionalProfile = readDomainCookie('additional_profile') === 'true';

  // If the user is adding an additional profile, don't redirect them away from the onboarding flow
  if (isAdditionalProfile) {
    return false;
  }

  // Redirect users who have not completed their registration process
  // and are not already on the correct page.
  if (onboardingState !== 'COMPLETE' && !window.location.href.includes(stateToRouteMap[onboardingState])) {
    window.location.assign(routeForOnboardingState(onboardingState));
    return true; // Indicate that a redirect happened
  }

  return false; // No redirect needed
}

async function redirectIfOnboarded(apolloProvider, account) {
  if (!account?.isSitter()) return;

  const onboardingState = await sitterOnboardingState(apolloProvider);
  const isOnOnboardingPage = Object.values(stateToRouteMap).includes(window.location.pathname);

  const isAdditionalProfile = readDomainCookie('additional_profile') === 'true';

  // Redirect users who have completed registration & are trying to access onboarding pages
  // Skip redirection if additional profile is true
  if (onboardingState === 'COMPLETE' && isOnOnboardingPage && !isAdditionalProfile) {
    window.location.assign('/account/providers/dashboard');
  }
}

export { sitterOnboardingState, redirectIfNotOnboarded, redirectIfOnboarded, routeForOnboardingState };
